import { NgClass } from '@angular/common';
import {
  ApplicationRef,
  ChangeDetectorRef,
  Component, ComponentRef,
  EnvironmentInjector, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewContainerRef
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['overlay.component.scss'],
    imports: [
        NgClass,
        TranslateModule
    ]
})
export class OverlayComponent implements OnInit{

  private _innerComponent: Type<any>
  @Input() set innerComponent(value: Type<any>) {
    this._innerComponent = value;
  }

  @Input() showClose: boolean = true;

  //to be able to overrule the rounded and bg properties
  private _elementClass:string = "";
  @Input() set elementClass (value: string){
    this._elementClass = value;
    this.setDefaultClasses()
  }
  get elementClass(){
    this.setDefaultClasses()
    return this._elementClass
  }

  setDefaultClasses(){
    if(!this._elementClass.includes('rounded-'))
      this._elementClass += ' rounded-lg'
    if(!this._elementClass.includes('bg-'))
      this._elementClass += ' bg-white'
  }

  @Output() createdComponent: EventEmitter<any> = new EventEmitter<any>()


  //to make sure it is always closed
  private _modal: NgbModalRef
  set modal(value: NgbModalRef){
    this._modal = value;
    this._modal.dismissed.pipe(takeUntil( this._modal.closed)).subscribe(()=>{
      this._modal.close()
    })
  }
  get modal(){
    return this._modal
  }

  componentRef: ComponentRef<Component>;
  @ViewChild('dynamicContent', { read: ViewContainerRef }) private dynamicContentContainer!: ViewContainerRef;


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private injector: EnvironmentInjector,
    private appRef: ApplicationRef,
    // private _orderService: OrderService,
  )
  { }


  ngOnInit() {

  }

  public ngAfterViewChecked() {
    if (
      this.dynamicContentContainer
      && this.dynamicContentContainer.length === 0
      && this._innerComponent
    ) {
      this.createComponent(this._innerComponent);
    }
  }

  public markForCheck() {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) { /* empty */ }

    this._changeDetectorRef.markForCheck();
  }

  createComponent(component: Type<any>) {
    this.dynamicContentContainer.clear();
    if (component) {
      this.componentRef = this.modal.componentInstance.dynamicContentContainer.createComponent(component, { injector: this.modal.componentInstance.dynamicContentContainer.injector });
    }
    this.markForCheck();

    this.createdComponent.emit(this.componentRef.instance);
  }

  closeOverlay() {
    if(this.modal){
      this.modal.close();
    }
  }




}
